export const BASE_APPLICATION_PATH = '/application';
export const BASE_DASHBOARD_PATH = '/dashboard';
export const BASE_INTEGRATION_PATH = '/connect';
export const BASE_REGISTRATION_PATH = '/register';
export const BASE_LOGIN_PATH = '/login';
